import { render } from "./XgPlayer.vue?vue&type=template&id=67c0ff72&scoped=true"
import script from "./XgPlayer.vue?vue&type=script&lang=js"
export * from "./XgPlayer.vue?vue&type=script&lang=js"

import "./XgPlayer.vue?vue&type=style&index=0&id=67c0ff72&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c0ff72"]])

export default __exports__